import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center font-montserrat items-center" }
const _hoisted_2 = { class: "container max-w-[1024px]" }
const _hoisted_3 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[10px]" }
const _hoisted_4 = { class: "container max-w-[1024px] relative w-full my-[50px]" }
const _hoisted_5 = { class: "w-full p-[10px] relative md:flex" }
const _hoisted_6 = { class: "relative w-full text-3xl text-left flex" }
const _hoisted_7 = { class: "text-blue-800 mb-[10px]" }
const _hoisted_8 = { class: "md:text-left text-center" }
const _hoisted_9 = { class: "w-full overflow-hidden max-h-[300px] relative p-[10px]" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "w-full relative p-[10px] overflow-x-hidden max-w-screen h-auto" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "w-full relative p-[10px]" }
const _hoisted_14 = { class: "w-full relative pt-[10px] pb-[20px] border-b border-gray-500 flex justify-between items-center" }
const _hoisted_15 = { class: "flex justify-center items-center" }
const _hoisted_16 = { class: "mx-[10px]" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "my-[20px] w-full relative" }
const _hoisted_20 = {
  key: 0,
  class: "my-[20px] w-full relative"
}

import HeaderComponent from '../components/HeaderComponent.vue';
import One_comment from '../components/One_comment.vue';
import CommentComponent from '../components/commentComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axiosInstance from '@/plugins/axios';
interface Comment {
  id: number;
  content: string;
  article: number;
}

interface Article {
  id: number;
  comments: Comment[];
  author: string;
  title: string;
  content: string;
  image: string;
  date: string;
  source: string;
  is_published: boolean;
  likes: Like[];
  is_liked_by_current_user: boolean;
}


interface Like {
  id: number;
  ip_address: string;
  article: number;
}

interface Comment {
  username: string;
  content: string;
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'article',
  setup(__props) {

let isSuperUser = ref(false);

const router = useRouter();

const articleId = router.currentRoute.value.params.id;

const article = ref<Article>({
  id: 0,
  comments: [],
  author: '',
  title: '',
  content: '',
  image: '',
  date: '',
  source: '',
  is_published: false,
  likes: [],
  is_liked_by_current_user: false
});


function extractTextFromHTML(html: any) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.innerText || "";
}

const allComments = ref<Comment[]>([]);
const sortedComments = ref<Comment[]>([]);

const loadAllComments = async () => {
  try {
    const response = await axiosInstance.get(`/articles/${articleId}/`);
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const comments = response.data.comments || [];
      allComments.value = comments;
      sortedComments.value = comments.slice().sort((a, b) => b.id - a.id);
      latestComment.value = null;
    }
  } catch (error) {
    console.error('Erreur lors du chargement de tous les commentaires :', error);
  }
};


const showAllComments = async () => {
  await loadAllComments();
};

const textWithoutHTML = extractTextFromHTML(article.value.content);


const loadArticleDetails = async (id: any) => {
  try {
    const response = await axiosInstance.get(`/articles/${id}/`);
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { title, author, content, image, date, source, is_published, comments, likes, is_liked_by_current_user } = response.data;
      article.value = {
        id,
        title,
        author,
        content,
        image,
        date,
        source,
        is_published,
        comments: comments || [],
        likes: likes || [],
        is_liked_by_current_user,
      };
    }
  } catch (error) {
    console.error('Erreur lors du chargement des détails de l\'article', error);
  }
};



const pageTitle = ref('IronSecur | Nom article');
const id = ref(''); 
onMounted(() => {
  const articleId = router.currentRoute.value.params.id;
  id.value = articleId;
  loadArticleDetails(articleId);
});

const Like = async () => {
  try {

    await axiosInstance.post(`/articles/${articleId}/likes/`);

    await loadArticleDetails(articleId);

  } catch (error) {
    console.error('Error toggling like:', error);
  }
};

const unLike = async () => {
  try {

    await axiosInstance.delete(`/articles/${articleId}/likes/${article.value.likes[0].id}/`);

    await loadArticleDetails(articleId);

  } catch (error) {
    console.error('Error toggling like:', error);
  }
};



const latestComment = ref<Comment | null>(null);

const fetchComments = async () => {
  try {
    const response = await axiosInstance.get(`/articles/${articleId}/`);
    const comments: Comment[] = response.data.comments || [];
    allComments.value = comments;

    if (comments.length > 0) {
      latestComment.value = comments[comments.length - 1]; 
    }
  } catch (error) {
    console.error('Erreur lors de la récupération des commentaires :', error);
  }
};


let user = ref({});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    user.value = response.data;
    isSuperUser.value = response.data.is_staff;
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchComments();
  fetchUserProfile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(article.value.title), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: article.value.image,
              alt: "",
              class: "w-full max-h-[400px]"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              innerHTML: article.value.content,
              class: "max-w-screen ql-editor h-auto"
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(article.value.comments.length) + " Comments", 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(article.value.likes.length), 1),
                (article.value.is_liked_by_current_user)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("i", {
                        class: "text-red-500 text-2xl cursor-pointer fa-solid fa-heart",
                        onClick: unLike
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("i", {
                        class: "fa-regular fa-heart text-2xl cursor-pointer text-black",
                        onClick: Like
                      })
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(CommentComponent),
              _createVNode(One_comment, {
                isSuperUser: _unref(isSuperUser),
                latestComment: latestComment.value,
                allComments: sortedComments.value
              }, null, 8, ["isSuperUser", "latestComment", "allComments"]),
              (latestComment.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (allComments.value.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "w-full p-[20px] font-bold rounded-[5px] bg-blue-500 text-white text-sm",
                          onClick: showAllComments
                        }, "Load more comments"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})